// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__pC0PbRgjoTwVXa1cOiDr","button":"button__y_VpNDMqt5QS9e10UhNd"};